export type FrameHandle =
  | { kind: 'raf'; id: number }
  | { kind: 'timeout'; id: number };

export function now(): number {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }

  return Date.now();
}

export function requestFrame(callback: (timestamp: number) => void): FrameHandle {
  if (typeof window.requestAnimationFrame === 'function') {
    return {
      kind: 'raf',
      id: window.requestAnimationFrame(callback),
    };
  }

  return {
    kind: 'timeout',
    id: window.setTimeout(() => {
      callback(now());
    }, 16),
  };
}

export function cancelFrame(handle: FrameHandle | null): void {
  if (handle === null) {
    return;
  }

  if (handle.kind === 'raf') {
    window.cancelAnimationFrame(handle.id);
    return;
  }

  window.clearTimeout(handle.id);
}

export function hasResizeObserver(): boolean {
  return typeof ResizeObserver !== 'undefined';
}

export function hasMutationObserver(): boolean {
  return typeof MutationObserver !== 'undefined';
}

export function hasMatchMedia(): boolean {
  return typeof window.matchMedia === 'function';
}
